
export default function TileAdhesiveHero() {
  return (
    <section className="relative bg-gradient-to-br from-[#1A1A1A] to-[#2d2d2d] text-white py-12 md:py-20 px-4 md:px-8 overflow-x-hidden">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col md:flex-row items-center gap-8 md:gap-12">
          <div className="w-full md:w-1/2">
            <span className="inline-block text-white/60 uppercase tracking-widest text-xs font-semibold mb-4">
              Everyday · Contractor Grade · Elite Pro Series
            </span>
            <h1 className="font-['Montserrat'] font-bold text-[2rem] md:text-4xl lg:text-5xl mb-6 leading-tight">
              Tile Adhesive
            </h1>
            <p className="text-base md:text-lg text-gray-300 mb-6">
              Professional bonding strength for every tile type and surface. Available across all three performance tiers — from everyday DIY projects to the most demanding commercial installations.
            </p>
          </div>
          <div className="w-full md:w-1/2">
            <div className="w-full h-[400px] rounded-lg overflow-hidden bg-[#2d2d2d] flex items-center justify-center">
              <img
                src="https://static.readdy.ai/image/783dd8c3d2d1f38f9648f46144ac17f1/e5d9afd00fd9a5d6b1108c8772c59acb.png"
                alt="Tile Adhesive"
                className="w-full h-full object-contain"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
